import {
  createRouter,
  createWebHistory,
  NavigationGuardNext,
  RouteLocationNormalized,
  RouteRecordRaw
} from 'vue-router';
import { useJwtStore } from '@/store/modules/jwt';
import { WaitUntilRefreshed, roleChecker } from '@/utils/jwt';
import { UserTypes } from '@/store/models/user';
import { authRoutes } from '@/router/auth';
import { generalRoutes } from '@/router/general';
import { adminRoutes } from '@/router/admin';

const routes: Array<RouteRecordRaw> = [
  {
    path: '',
    name: 'LandingPage',
    component: () => import('@/views/pages/LandingPageNew.vue')
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/pages/LoginPage.vue')
  },
  {
    path: '',
    component: () => import('@/views/layouts/MainLayout.vue'),
    children: [...authRoutes, ...generalRoutes, ...adminRoutes]
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: () => import('@/views/pages/NotFound.vue')
  }
];

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  scrollBehavior: () => ({ left: 0, top: 0 }),
  routes
});

export default router;

router.beforeEach(
  async (
    to: RouteLocationNormalized,
    _from: RouteLocationNormalized,
    next: NavigationGuardNext
  ) => {
    if (to.matched.some(record => record.meta.requiresAuth)) {
      await WaitUntilRefreshed();
      const jwtStore = useJwtStore();
      if (jwtStore.loggedIn) {
        if (to.meta) {
          if (
            to.meta.allowedRoles &&
            !roleChecker(to.meta.allowedRoles as UserTypes[])
          ) {
            next({ name: 'LandingPage' });
            return;
          }
        }
        next();
      } else {
        next({ name: 'LandingPage' });
      }
    } else if (to.name === 'Login' || to.name === 'Registration') {
      await WaitUntilRefreshed();
      const jwtStore = useJwtStore();
      if (jwtStore.loggedIn) {
        next({ name: 'Home' });
      } else {
        next();
      }
    } else if (to.name === 'RegistrationSuccess') {
      next();
    } else {
      next();
    }
  }
);
